
import { GetMembershipResponse } from '../../clevermaps-js-sdk';
import { useCleverMapsGetEndpoint } from '../useCleverMapsGetEndpoint';
import { useCleverMapsCurrentAccount } from './useCleverMapsCurrentAccount';

export const useCleverMapsMembership = (props: { projectId: string | undefined }): { response: GetMembershipResponse | null, error: number | null } => {
	const account = useCleverMapsCurrentAccount();
	return  useCleverMapsGetEndpoint<GetMembershipResponse>(account?.id ? `/rest/projects/${props.projectId}/members?accountId=${account?.id}` : null)
}
